// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cq7fYZLBK6avaE {
  margin-bottom: var(--ds-space-200, 16px);
  padding-top: var(--ds-space-200, 16px);
}
.cq7fYZLBK6avaE.w7CMBGoNhYL9_1 {
  padding-top: var(--ds-space-600, 48px);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `cq7fYZLBK6avaE`,
	"fullscreen": `w7CMBGoNhYL9_1`
};
export default ___CSS_LOADER_EXPORT___;
